export default __webpack_public_path__ + "static/media/carousel_left_arrow.bac8fc57.svg";